import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { GlobalMessageService } from '@spartacus/core'
import {
  PageLayoutService,
  ProductListComponent,
  ProductListComponentService,
  ViewConfig,
  ViewModes
} from '@spartacus/storefront'
import { BehaviorSubject } from 'rxjs'
import { ICustomProduct } from '../../../models/ICustomProduct'
import { CompareProductsService } from '../compare-products/compare-products.service'

@Component({
    selector: 'app-custom-product-list',
    templateUrl: './custom-product-list.component.html',
    styleUrls: ['./custom-product-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomProductListComponent extends ProductListComponent implements OnInit, AfterViewInit {
  @ViewChild('compareContainer') compareContainer: ElementRef
  viewModes = ViewModes
  public showPageView = false

  constructor(
    pageLayoutService: PageLayoutService,
    productListComponentService: ProductListComponentService,
    globalMessageService: GlobalMessageService,
    scrollConfig: ViewConfig,
    private compareProductsService: CompareProductsService,
    private readonly router: Router
  ) {
    super(pageLayoutService, productListComponentService, globalMessageService, scrollConfig)
  }

  get selectedProducts(): BehaviorSubject<ICustomProduct[]> {
    return this.compareProductsService.getCompareProductsList()
  }

  ngOnInit(): void {
    this.setViewMode(ViewModes.List)
  }

  //need to set compareContainer ElementRef on service, to scroll to compareContainer, after running addtocompare in service
  //triggered by appCompare directive in child components
  ngAfterViewInit(): void {
    this.compareProductsService.setCompareContainer(this.compareContainer)
  }

  setViewMode(mode: ViewModes): void {
    this.viewMode$.next(mode)
  }

  removeProductToCompare(product: ICustomProduct): void {
    this.compareProductsService.removeProductFromCompare(product)
  }

  //After navigating to compare-products set compareservice to initial state
  onCompareProducts(selectedProducts: ICustomProduct[]): void {
    const selectedProductCodes: string = this.generateCompareQueryParameters(selectedProducts)
    this.router
      .navigate(['compare-products'], { queryParams: { productcodes: selectedProductCodes } })
      .then(() => this.compareProductsService.initializeCompareService())
  }

  private generateCompareQueryParameters(selectedProducts): string {
    let selectedProductCodes = ''
    selectedProducts.forEach((selectedProduct) => {
      selectedProductCodes += selectedProduct.code + ','
    })
    selectedProductCodes = selectedProductCodes.slice(0, -1)
    return selectedProductCodes
  }

  public scrollToTop(): void {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }
}
